import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import type { NavLink } from '../data/fixer-content.js'
import { useFixerContent } from '../hooks/i18n/usePageContent.js'

interface FixerMobileNavProps {
  links: NavLink[]
  ctaHref: string
  ctaLabel: string
}

export function FixerMobileNav({ links, ctaHref, ctaLabel }: FixerMobileNavProps) {
  const { t } = useTranslation('marketing')
  const [open, setOpen] = useState(false)
  const sectionsAria = useFixerContent().chrome.sectionsAria

  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  return (
    <div className="fixer-mobile-nav md:hidden">
      <button
        type="button"
        className="fixer-mobile-nav-toggle"
        aria-expanded={open}
        aria-controls="fixer-mobile-nav-panel"
        onClick={() => setOpen(v => !v)}
      >
        <span className="sr-only">{open ? t('fixerNav.closeMenu') : t('fixerNav.openMenu')}</span>
        <span className="fixer-mobile-nav-bars" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </button>

      {open ? (
        <button
          type="button"
          className="fixer-mobile-nav-backdrop"
          aria-label={t('fixerNav.closeMenuBackdrop')}
          onClick={() => setOpen(false)}
        />
      ) : null}

      <nav
        id="fixer-mobile-nav-panel"
        className={`fixer-mobile-nav-panel${open ? ' is-open' : ''}`}
        aria-label={sectionsAria}
        hidden={!open}
      >
        <div className="fixer-mobile-nav-links">
          {links.map(link => (
            <a
              key={link.href}
              href={link.href}
              className="fixer-mobile-nav-link"
              onClick={() => setOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </div>
        <a href={ctaHref} className="fixer-btn-primary fixer-mobile-nav-cta" onClick={() => setOpen(false)}>
          {ctaLabel}
        </a>
      </nav>
    </div>
  )
}
